import React from 'react';
import { Skeleton } from 'antd';

const HomeSkeleton: React.FC = () => {
    return (
        <div className="space-y-4">
            {/* Section 1 Skeleton */}
            <section className="px-4 md:px-10 py-2">
                <div className="bg-white shadow-md rounded-lg p-6">
                    <Skeleton active title={{ width: '30%' }} paragraph={{ rows: 2 }} />
                </div>
            </section>

            {/* Section 2 Skeleton */}
            <section className="px-4 md:px-10 py-2">
                <div className="bg-white shadow-md rounded-lg p-6">
                    <Skeleton active title={{ width: '40%' }} />
                    <div className="flex flex-col md:flex-row items-start space-y-6 md:space-y-0 md:space-x-6 mt-4">
                        <div className="w-full md:w-1/2">
                            <Skeleton.Button active style={{ width: '100%', height: '200px' }} block />
                        </div>
                        <div className="w-full md:w-1/2">
                            <Skeleton active paragraph={{ rows: 4 }} />
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 3 Skeleton */}
            <section className="px-4 md:px-10 py-2">
                <div className="bg-white shadow-md rounded-lg p-6">
                    <Skeleton active title={{ width: '35%' }} />
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="w-full">
                                <div className="w-full rounded-lg bg-gray-50 border border-gray-100 p-2">
                                    <Skeleton.Image active className="w-full !h-36 !w-full" />
                                </div>
                                <Skeleton active title={{ width: '60%' }} paragraph={false} className="mt-2 text-center" />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default HomeSkeleton;
